import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './public-pages/auth/auth.component';
import { AuthGuard, NoAuthGuard } from './core/guards';
import { InviteComponent } from './public-pages/invite/invite.component';
import { ForgotPasswordComponent } from './public-pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './public-pages/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: 'login',
    component: AuthComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'invite',
    component: InviteComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'reset',
    component: ResetPasswordComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./error/error.module').then((m) => m.ErrorModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollOffset: [0, 0],
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
